import { IHttpApi } from '@cian/http-api';
import {
  IBuyCustomPackageRequest,
  IMappers,
  fetchBuyCustomPackage,
} from '../../repositories/billing-service-packages-balancer/v4/buy-custom-package';
import { mapResponse200 } from './utils';
import { IBuyPackageResult } from '../../thunks/runBuyPackageLegacy/afterPurchasingPackage';

interface IParams {
  httpApi: IHttpApi;
  parameters: IBuyCustomPackageRequest;
}

export const buyCustomPackage = async (props: IParams): Promise<IBuyPackageResult> => {
  const { httpApi, parameters } = props;

  const mappers: IMappers<IBuyPackageResult> = {
    200: mapResponse200,
  };

  try {
    return (await fetchBuyCustomPackage({ httpApi, mappers, parameters })) as IBuyPackageResult;
  } catch (e) {
    return { isSuccess: false };
  }
};
